import Vconsole from 'vconsole'

function isDevelopment() {
  return process.env.NODE_ENV === 'development'
}

export function showVconsole(isForceShow) {
  if (isDevelopment() || isForceShow) {
    return new Vconsole()
  }
}
